export enum LogoTypeEnum {
    AuthorizationPagesLogo,
    MenuLogo,
    NavbarLogo
}
